import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CompanyDataService} from '../company-data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {JobsDataService} from '../../../../modules/jobs/jobs-data.service';

@Component({
    selector: 'app-company-jobs-list',
    templateUrl: './company-jobs-list.component.html',
    styleUrls: ['./company-jobs-list.component.scss'],
})

export class CompanyJobsListComponent implements OnInit {

    jobs: any = [];
    archivedJobs: any = [];
    unpublishedJobs: any = [];
    publishedJobs: any = [];
    draftJobs: any = [];
    expiredJobs: any = [];
    jobLogoPath: string;

    jobsLoaded = false;
    showAllJobs = true;
    showArchivedJobs = false;
    showUnpublishedJobs = false;
    showPublishedJobs = false;
    showDraftJobs = false;
    showExpiredJobs = false;
    jobStatus = '';

    duplicateResponse;
    duplicateSent;


    companyId: string;
    isAuthor: boolean ;

    constructor(private http: HttpClient,
                private companyDataService: CompanyDataService,
                private route: ActivatedRoute,
                private router: Router,
                private jobDataService: JobsDataService) {
    }

    ngOnInit() {
        this.route.params.subscribe((params: any) => {
            this.companyId = params.id;
        });

        if (this.companyId === undefined && this.router.url === '/joburile-mele') {
            this.getJobsFromCurrentCompany();
        } else {
            this.getJobsFromCompanyId();
        }

    }

    // Get all jobs form current company
    getJobsFromCurrentCompany() {
        this.companyDataService.getJobsFromCompany().subscribe(jobs => {
            this.jobs = jobs;
            this.isAuthor = true;
            this.jobsLoaded = true;
            this.sortJobsByStatus(this.jobs);
        })
    }

    // Duplicate job by id.
    duplicateJob(jobId) {
        this.duplicateSent = false;
        this.jobDataService.duplicateJob(jobId).subscribe((res: any) => {
            this.duplicateResponse = true;
            this.duplicateSent = true;
            setTimeout(() => {
                // this.router.navigate([`/editare-job/${res.reason}`])
                location.reload();
            }, 4000)
        }, error => {
            this.duplicateResponse = false;
            this.duplicateSent = true;
        })
    }

    // Get all jobs from company by ID
    getJobsFromCompanyId() {
        this.companyDataService.getJobsFromCompanyId(this.companyId).subscribe(jobs => {
            this.jobs = jobs;
            this.sortJobsByStatus(this.jobs);
        })
        this.jobsLoaded = true;
    }

    // Change Job Status
    changeJobStatus(jobId, jobStatus) {
        this.companyDataService.changeJobStatus(jobId, jobStatus).subscribe(respData => {
            this.getJobsFromCurrentCompany();
            this.sortJobsByStatus(this.jobs);
        })
    }

    // Sort Jobs By Status
    sortJobsByStatus(jobs: any) {
        this.archivedJobs = [];
        this.unpublishedJobs = [];
        this.draftJobs = [];
        this.expiredJobs = [];
        this.publishedJobs = [];
        for (let i = 0; i < jobs.length; i++) {
            // Push only the jobs with the specific status
            if (jobs[i].status === 'Archived') {
                this.archivedJobs.push(jobs[i]);
            } else if (jobs[i].status === 'Pending_review') {
                this.unpublishedJobs.push(jobs[i]);
            } else if (jobs[i].status === 'Draft') {
                this.draftJobs.push(jobs[i]);
            } else if (jobs[i].status === 'Expired') {
                this.expiredJobs.push(jobs[i]);
            } else if (jobs[i].status === 'Published') {
                this.publishedJobs.push(jobs[i]);
            }
        }
    }

    // Tab Display
    displayApps(arg) {
        if (arg === 'all') {
            this.showAllJobs = true;
            this.showArchivedJobs = false;
            this.showUnpublishedJobs = false;
            this.showPublishedJobs = false;
            this.showDraftJobs = false;
            this.showExpiredJobs = false;
        } else if (arg === 'archived') {
            this.showAllJobs = false;
            this.showArchivedJobs = true;
            this.showUnpublishedJobs = false;
            this.showPublishedJobs = false;
            this.showDraftJobs = false;
            this.showExpiredJobs = false;
        } else if (arg === 'pending_review') {
            this.showAllJobs = false;
            this.showArchivedJobs = false;
            this.showUnpublishedJobs = true;
            this.showPublishedJobs = false;
            this.showDraftJobs = false;
            this.showExpiredJobs = false;
        } else if (arg === 'published') {
            this.showAllJobs = false;
            this.showArchivedJobs = false;
            this.showUnpublishedJobs = false;
            this.showPublishedJobs = true;
            this.showDraftJobs = false;
            this.showExpiredJobs = false;
        } else if (arg === 'draft') {
            this.showAllJobs = false;
            this.showArchivedJobs = false;
            this.showUnpublishedJobs = false;
            this.showPublishedJobs = false;
            this.showDraftJobs = true;
            this.showExpiredJobs = false;
        } else if (arg === 'expired') {
            this.showAllJobs = false;
            this.showArchivedJobs = false;
            this.showUnpublishedJobs = false;
            this.showPublishedJobs = false;
            this.showDraftJobs = false;
            this.showExpiredJobs = true;
        }
    }
}
